import type { ReactNode } from 'react';

export const symbol_child_care: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M552-515q-13-13-13-32t13-32q13-13 32-13t32 13q13 13 13 32t-13 32q-13 13-32 13t-32-13Zm-209 0q-13-13-13-32t13-32q13-13 32-13t32 13q13 13 13 32t-13 32q-13 13-32 13t-32-13Zm35 199q-46-30-72-79h348q-26 49-72 79t-102 30q-56 0-102-30Zm-37.5 167.5Q275-177 226-226t-77.5-114.5Q120-406 120-480t28.5-139.5Q177-685 226-734t114.5-77.5Q406-840 480-840t139.5 28.5Q685-783 734-734t77.5 114.5Q840-554 840-480t-28.5 139.5Q783-275 734-226t-114.5 77.5Q554-120 480-120t-139.5-28.5Zm351-119Q780-355 780-478t-87-215q-87-92-215-92h-18q-7 0-18 1-2 8-3.5 19t-1.5 19q0 25 16.5 41.5T495-688q12 0 20-1.5t15-1.5q10 0 17 5t7 15q0 16-15 24.5t-44 8.5q-46 0-77-31t-31-77q0-5 .5-13t2.5-13q-91 33-150.5 110T180-482q0 123 88.5 212.5T480-180q123 0 211.5-87.5ZM480-482Z"
		/>
	</svg>
);
